import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'

import IntegrationsAvailable from '../IntegrationsAvailable/IntegrationsAvailable'
import IntegrationsConfigurationsSkeleton from '../IntegrationsConfigurationsSkeleton/IntegrationsConfigurationsSkeleton'
import IntegrationsConnected from '../IntegrationsConnected/IntegrationsConnected'
import * as Styles from './styles'

const IntegrationsContent = ({
  gettingIntegrations,
  integrations,
  onToggle,
  onUninstall,
  handleEditIntegration,
  hasEditPermission,
}) => {
  if (gettingIntegrations) {
    return <IntegrationsConfigurationsSkeleton />
  }

  if (!integrations?.length) {
    return <NoResultsFound />
  }

  return (
    <Styles.Container>
      <IntegrationsConnected
        integrations={integrations.filter(integration => integration.id)}
        onToggle={onToggle}
        onUninstall={onUninstall}
        handleEditIntegration={handleEditIntegration}
        disabled={!hasEditPermission}
      />
      {hasEditPermission && (
        <IntegrationsAvailable
          integrations={integrations.filter(integration => !integration.id)}
          handleEditIntegration={handleEditIntegration}
        />
      )}
    </Styles.Container>
  )
}

export default IntegrationsContent
